// extracted by mini-css-extract-plugin
module.exports = {"img":"CompleteIcon_img__1urwJ"};